// EditAdmin.tsx
import React, { useState } from "react";
import { Modal } from "@mantine/core";
import { PasswordInput, TextInput, Text, Button, Group } from "@mantine/core";
import { RowDataStaff } from "./types";
import classes from "./Staff.module.css";

interface EditAdminProps {
  isVisible: boolean;
  onClose: () => void;
  onSaveChanges: (EditedStaff: RowDataStaff) => void;
  initialData: RowDataStaff;
}

const EditAdmin: React.FC<EditAdminProps> = ({
  isVisible,
  onClose,
  onSaveChanges,
  initialData,
}) => {
  const [EditedStaff, setEditedStaff] = useState<RowDataStaff>(initialData);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handleSaveChanges = () => {
    onSaveChanges({
      ...EditedStaff,
      action: "Edit",
    });
  };

  return (
    <Modal
      opened={isVisible}
      onClose={onClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Staff
        </div>
      }
    >
      <form onSubmit={handleSaveChanges}>
        {/* Display fields for editing */}
        <div className={classes.spacing}>
          <TextInput
            label="Name"
            maxLength={255}
            value={EditedStaff.name}
            onChange={(e) =>
              setEditedStaff({ ...EditedStaff, name: e.currentTarget.value })
            }
          />
          <TextInput
            label="Email"
            maxLength={255}
            value={EditedStaff.email}
            onChange={(e) =>
              setEditedStaff({ ...EditedStaff, email: e.currentTarget.value })
            }
          />
          {/* <PasswordInput
          value={EditedStaff.password}
          maxLength={255}
          onChange={(event) =>
            setEditedStaff({
              ...EditedStaff,
              password: event.currentTarget.value,
            })
          }
          placeholder="Your password"
          label="Password"
        />

        <PasswordInput
          value={EditedStaff.reenterPassword}
          maxLength={255}
          onChange={(event) => {
            setEditedStaff({
              ...EditedStaff,
              reenterPassword: event.currentTarget.value,
            });
            setPasswordsMatch(
              EditedStaff.password === event.currentTarget.value
            );
          }}
          placeholder="Reenter your password"
          label="Reenter Password"
        />

        {!passwordsMatch && (
          <Text c="red" mt="sm">
            Passwords do not match
          </Text>
        )} */}
          <Group className={classes.buttonBottom}>
            <Button onClick={() => onClose()} className={classes.buttonCancel}>
              Back
            </Button>
            <Button type="submit" className={classes.buttonSaveChanges}>
              Save Changes
            </Button>
          </Group>
        </div>
      </form>
    </Modal>
  );
};

export default EditAdmin;
